import { useTranslations } from '@i18n/useLanguage'
import { BusinessProfile } from '@schema/businessProfile'
import { addressBuilder } from '@app/util/helpers'
import useMediaQuery from '@app/util/useMediaQuery'
import {
  DetailsPanel,
  DetailsPanelItem,
} from '@app/components/blocks/detailsPanel/DetailsPanel'
import { useMemo } from 'react'
import { TextLink } from '@app/components/core/link/TextLink'

export const RightColumn = ({
  businessProfile,
}: {
  businessProfile: BusinessProfile
}) => {
  const translations = useTranslations().app.businessProfilePage
  const isMobile = useMediaQuery()

  const items: DetailsPanelItem[] = useMemo(() => {
    const items = []

    if (businessProfile.address) {
      items.push({
        label: translations.address,
        value: addressBuilder(businessProfile.address),
      })
    }
    if (businessProfile.contact?.phone) {
      items.push({
        label: translations.phone,
        value: (
          <TextLink
            to={`tel:${businessProfile.contact.phone}`}
            target="_blank"
            externalURL
          >
            {businessProfile.contact.phone}
          </TextLink>
        ),
      })
    }
    if (businessProfile.contact?.website) {
      items.push({
        label: translations.website,
        value: (
          <TextLink
            to={businessProfile.contact.website}
            target="_blank"
            externalURL
          >
            {businessProfile.contact.website}
          </TextLink>
        ),
      })
    }
    if (businessProfile.contact?.email) {
      items.push({
        label: translations.email,
        value: (
          <TextLink
            externalURL
            to={`mailto:${businessProfile.contact.email}`}
            target="_blank"
          >
            {businessProfile.contact.email}
          </TextLink>
        ),
      })
    }

    return items
  }, [
    businessProfile.address,
    businessProfile.contact,
    translations.address,
    translations.phone,
    translations.website,
    translations.email,
  ])

  return (
    <DetailsPanel
      items={items}
      style={{
        alignItems: 'stretch',
        flex: isMobile ? '1' : '1 1 23rem',
        minWidth: '23rem',
      }}
    />
  )
}
